<button
  class="sidebar_btn"
  name="main menu"
  mat-icon-button
  (click)="_pktrAppMenuService.open()"
  aria-label="main menu"
  tabindex="1"
>
  <span></span>
  <span></span>
  <span></span>
</button>